import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ThunkDispatch } from '@reduxjs/toolkit'

import { editPhotoActions } from '../../../reducers/editPhoto'

/**
 * キーボードショートカットを管理するカスタムHook
 * - Cmd/Ctrl + Z: Undo
 * - Cmd/Ctrl + Shift + Z または Cmd/Ctrl + Y: Redo
 * - Escape: Clear All
 */
export function useKeyboardShortcuts(): void {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
    const { historyIndex, historyStack, lines, aiEraserLines } = useSelector((state: any) => state.editPhoto)

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            // Cmd/Ctrl + Z: Undo
            if ((e.metaKey || e.ctrlKey) && e.key === 'z' && !e.shiftKey) {
                e.preventDefault()
                if (historyIndex > 0) {
                    dispatch(editPhotoActions.undo())
                }
            }

            // Cmd/Ctrl + Shift + Z または Cmd/Ctrl + Y: Redo
            if (
                ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key === 'z') ||
                ((e.metaKey || e.ctrlKey) && e.key === 'y')
            ) {
                e.preventDefault()
                if (historyIndex < historyStack.length - 1) {
                    dispatch(editPhotoActions.redo())
                }
            }

            // Escape: Clear All
            if (e.key === 'Escape') {
                e.preventDefault()
                if (lines.length > 0 || aiEraserLines.length > 0) {
                    dispatch(editPhotoActions.clearAll())
                    // 明示的に再描画を実行して画面をクリア
                    setTimeout(() => dispatch(editPhotoActions.drawPreviewImage({})), 10)
                }
            }
        }

        window.addEventListener('keydown', handleKeyDown)

        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [dispatch, historyIndex, historyStack.length, lines.length, aiEraserLines.length])
}
